import React from 'react';
import { Alert, Box, LinearProgress, Portal, Snackbar } from '@mui/material';

// DetailPanelActions renders cross-tab transient UI for the detail drawer:
// long-running refresh progress and toasts that should outlive a specific tab body.
const DetailPanelActions = ({ refreshProgress, snackbar, onSnackbarClose }) => {
  return (
    <>
      {refreshProgress?.isActive && (
        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            backgroundColor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <LinearProgress
            variant="determinate"
            value={refreshProgress.progress}
            sx={{
              height: 3,
              '& .MuiLinearProgress-bar': {
                transition: 'transform 0.3s linear',
              },
            }}
          />
        </Box>
      )}

      <Portal>
        <Snackbar
          data-testid="detailpanel-snackbar"
          key={snackbar.key}
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={onSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          sx={{ zIndex: (theme) => (theme?.zIndex?.modal || 1300) + 300 }}
        >
          <Alert
            data-testid="detailpanel-snackbar-alert"
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: '100%', cursor: snackbar.onClick ? 'pointer' : 'default' }}
            onClick={() => {
              if (snackbar.onClick) {
                snackbar.onClick();
              }
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Portal>
    </>
  );
};

export default DetailPanelActions;
